import { render, staticRenderFns } from "./respond-to-comment.vue?vue&type=template&id=f5f97a42&scoped=true&"
import script from "./respond-to-comment.vue?vue&type=script&lang=ts&"
export * from "./respond-to-comment.vue?vue&type=script&lang=ts&"
import style0 from "./respond-to-comment.vue?vue&type=style&index=0&id=f5f97a42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f97a42",
  null
  
)

export default component.exports